import { sendRequest } from "../axios";
import roles from "../plugins/roles";

export default {
  state: {
    user: {
      isAuthenticated: false,
      token: null,
      name: null,
      expiration: null,
      user_id: null,
      profile: {
        emailContact: null,
        famil: null,
        name: null,
        otch: null,
        phone: null,
        role: null,
      },
    },
  },
  mutations: {
    SET_USER(state, payload) {
      state.user.isAuthenticated = true;
      state.user.token = payload.token;
      state.user.name = payload.name;
      state.user.expiration = payload.expiration;
      state.user.user_id = payload.user_id;
    },
    CLEAR_USER(state) {
      state.user.isAuthenticated = false;
      state.user.token = null;
      state.user.name = null;
      state.user.expiration = null;
      state.user.user_id = null;
    },
    SET_ROLE(state, payload) {
      state.user.profile.role = payload;
    },
    SET_PROFILE(state, payload) {
      state.user.profile = payload;
    },
  },
  actions: {
    async REMOVE_USER({ commit }, payload) {
      const { data } = await sendRequest("removeUser", "post", payload);
      return data;
    },
    set_profile_role({ commit }, payload) {
      commit("SET_ROLE", payload);
    },
    clear_user({ commit }) {
      commit("SET_PROCESSING", true);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("expiration");
      localStorage.removeItem("url");
      localStorage.removeItem("user_id");
      commit("CLEAR_USER");
      commit("SET_PROCESSING", false);
    },
    log_in_from_cache({ commit }) {
      const token = localStorage.getItem("token");
      const name = localStorage.getItem("user");
      const expiration = localStorage.getItem("expiration");
      const user_id = localStorage.getItem("user_id");
      commit("SET_USER", { token, name, expiration, user_id });
    },
    DEBUG({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("auth/debug", "post", payload).then((response) => {
          commit("SET_PROCESSING", false);
          commit("CLEAN_ERROR", false);
          resolve(response);
        });
      });
    },
    SIGNIN({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("auth/loginAgent", "post", payload, () => {
          localStorage.removeItem("token");
        }).then((response) => {
          commit("SET_ERROR_API", response.data.error);

          if (response.data.error === "OK") {
            const token = response.data.access_token;
            const name = response.data.name;
            const expiration = response.data.expires_at;
            const user_id = response.data.user_id;
            const profile = response.data.profile;
            commit("SET_PROFILE", profile);
            const url = localStorage.getItem("url");
            // axios.defaults.headers.common["Authorization"] = "Bearer " + token;

            localStorage.setItem("user_id", user_id);
            localStorage.setItem("profile", JSON.stringify(profile));
            localStorage.setItem("token", token);
            localStorage.setItem("user", name);
            localStorage.setItem("expiration", expiration);
            url === undefined &&
              url === null &&
              localStorage.setItem("url", response.data.redirect);

            commit("SET_USER", { token, name, expiration, user_id });
            commit("CLEAN_ERROR", false);
          }
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SIGNUP({ commit }, payload) {
      //регистрация
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("auth/signupAgent", "post", payload, (error) => {
          localStorage.removeItem("token");
        }).then((response) => {
          commit("SET_PROCESSING", false);
          commit("CLEAN_ERROR", false);
          commit("SET_ERROR_API", response.data.error);
          resolve(response);
        });
      });
    },
    RECOVER({ commit }, payload) {
      //регистрация
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("recoverAgent", "post", payload, () => {
          localStorage.removeItem("token");
        }).then((response) => {
          commit("SET_PROCESSING", false);
          commit("CLEAN_ERROR", false);
          resolve(response.data);
        });
      });
    },
  },
  getters: {
    isAuthenticated: (state) => state.user.isAuthenticated,
    user_id: (state) => state.user.user_id,
    role: (state) => {
      const getLocalRole = () =>
        localStorage.getItem("profile") !== undefined &&
        localStorage.getItem("profile") !== null
          ? JSON.parse(localStorage.getItem("profile")).role
          : roles !== undefined && roles.length >= 4 && roles[0].role;
      return state.user.profile.role !== null
        ? state.user.profile.role
        : getLocalRole();
    },
    profile: (state) => state.user.profile,
  },
};
